<template>
  <InputTipoInstrumento
    v-model="tipoInstrumento"
    class="tipo_instrumento rounded rounded-lg"
    :tool-tip-informacao="''"
    :multiplos="false"
  />
</template>

<script>
import helpers from '@common/utils/helpers';
import InputTipoInstrumento from '@/components/inputs/especificos/InputTipoInstrumento'

export default {
    components: {
        InputTipoInstrumento
    },
    props:{
        criterio: {
          default: '',
          required: false,
        }
    },
    data() {
        return {
            tipoInstrumento: null,
            items: [],
            loading: false
        };
    },
    watch:{
        tipoInstrumento(valor){
            let criterios = this.$store.getters['criterios/getCriterios']
            const itemEncontrado = criterios.find(item => item.sequencia === this.criterio.sequencia);
            
            if(itemEncontrado) {
                itemEncontrado['tipoInstrumentoId'] = valor.value
                itemEncontrado['tipoInstrumento'] =  {
                    nome: valor.text,
                    id: valor.value
                }
                this.$store.dispatch('criterios/updateCriterio', {updatedCriterio: itemEncontrado});
            }
        }
    },
    mounted() {
        this.fetchData();
        this.setup();
    },
    methods: {
        setup(){
            let criterios = this.$store.getters['criterios/getCriterios']
            const itemEncontrado = criterios.find(item => item.sequencia === this.criterio.sequencia);
            
            if(itemEncontrado) {
                this.tipoInstrumento = {
                    text: itemEncontrado.tipoInstrumento.nome,
                    value: itemEncontrado.tipoInstrumento.id
                }
                
                this.$store.dispatch('criterios/updateCriterio', {updatedCriterio: itemEncontrado});
            }
        },
        async fetchData() {
            this.items = helpers.TipoContratoEnum.sort(helpers.ordenarDropdown)
        }
    }
};
</script>   
<style>
.input-padrao .input-modal{
    display: none
}
.tipo_instrumento{
    display: flex;
}
</style>